import React from 'react'

export default function Social() {
  return (
    <div className="home__social">
<a href="https://www.instagram.com/acharyamanish945/?hl=en" className="home__social-icon" target='_blank'><i className="uil uil-instagram"></i></a>

<a href="https://www.linkedin.com/in/manish-raj-acharya-b62971218/" className="home__social-icon" target='_blank'><i className="uil uil-linkedin"></i></a>
<a href="https://github.com/22man67hh" className="home__social-icon" target='_blank'><i className="uil uil-github-alt"></i></a>
<a  href="https://wa.me/9863224162"  className="home__social-icon" target='_blank'><i className="uil uil-whatsapp-alt"></i></a>

    </div>
  )
}
